import { isPropertyNotNullOrUndefined } from '../is-property-not-null-or-undefined';

/**
 * A type narrowing filter for lists.
 * Basically does what `isPropertyNotNullOrUndefined` does except wraps it into a filter function
 *
 * @param key - The key to check
 * @returns A filter function
 */
export function isPropertyNotNullOrUndefinedFilter<
    T,
    Key extends keyof T,
    R extends T & {
        [key in Key]-?: Exclude<T[key], null | undefined>;
    },
>(key: Key): (val: T | null) => val is R {
    return (val: T | null): val is R => isPropertyNotNullOrUndefined(val, key);
}
